import React, { FC } from "react";
import { faArrowLeft } from "@fortawesome/pro-regular-svg-icons/faArrowLeft";
import { FontAwesomeIcon, FontAwesomeIconProps } from "@fortawesome/react-fontawesome";

export const ArrowLeft: FC<Omit<FontAwesomeIconProps, "icon">> = (props) => (
  <FontAwesomeIcon icon={faArrowLeft} {...props} />
);
